import { useEffect } from "react";
import { ProjetoDimensionado } from "src/components/projetos/dimensionados";
import { appStore } from "src/framework/store/AppStore";

const PAGE_TITLE = "Projeto dimensionado";

const ProjetosDimensionadosPage = () => {

  useEffect(() => {
    appStore.setPageTitle(PAGE_TITLE);
    return () => {
      appStore.setPageTitle("");
    }
  }, [])

  return (
    <div className="container">
      <div className="row">
        <div className="X12">
          <ProjetoDimensionado />
        </div>
      </div>
    </div>
  );
};

export { ProjetosDimensionadosPage };
